<template>
  <div class="po-r w100 bg-w card-shadow">
    <el-row class="w100 bor-b card-title">
      <el-col class="pl20" :span="18">
        <p class="font-16 blue">{{ title }}</p>
      </el-col>
      <el-col class="pr10 tx-r" :span="6">
        <!-- <router-link class="font-14 grey" :to="moreUrl">
                    {{ moreName }}
                    <i class="el-icon-arrow-right"></i>
                </router-link> -->
      </el-col>
    </el-row>
    <div class="po-r w100 pb10 card-main" v-loading="loading" element-loading-text="正在加载，请稍后" element-loading-background="rgba(0, 0, 0, 0.8)">
      <section v-if="data && data.wisedu.length > 0">
        <a class="po-r w100 flex-box al-c card-office-title hover" v-for="(val, key) in data.wisedu" :key="key" target="_blank" :href="val.url">
          <div class="flex-1 font-14 ellipsis">{{ val.label }}</div>
          <span class="grey">待办数量</span>
          <span class="in-block ml5 font-0 tx-c white card-list-badge">
            <span class="font-12">{{ val.value > 99 ? 99 : val.value }}</span>
          </span>
        </a>
      </section>

      <section v-if="data && data.onestop.length > 0">
        <router-link class="po-r w100 flex-box al-c card-office-title" :to="{ name: 'server_my_office' }">
          <div class="flex-1 font-14 ellipsis">【办事大厅】</div>
          <span class="grey">待办数量</span>
          <span class="in-block ml5 font-0 tx-c white card-list-badge">
            <span class="font-12">{{ data.onestop | sumCount }}</span>
          </span>
        </router-link>
        <!-- <router-link class="po-r w100 flex-box al-c card-office-list" v-for="(val, key) in data.onestop" :key="key" :to="{ name: 'server_info', query: { id: val.id }}">
          <div class="flex-1 grey font-14 ellipsis">|- {{ val.label }}</div>
          <span class="in-block font-0 tx-c white card-list-badge">
            <span class="font-12">{{ val.value > 99 ? 99 : val.value }}</span>
          </span>
        </router-link> -->
      </section>

      <p class="w100 pt20 pb20 tx-c grey" v-if="data && data.onestop.length == 0 && data.wisedu.length == 0">暂无待办提醒</p>

      <div class="w100 pt20 pb20 tx-c" v-if="error == 404">
        <el-button plain @click="error = 0, fetchData()">{{ errorMsg }}，点击重新加载</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "CardOffice",
  props: {
    title: {
      default: "待办提醒"
    },
    moreName: {
      default: "更多"
    },
    moreUrl: String,
    getUrl: String
  },
  data() {
    return {
      loading: false,
      error: 0,
      errorMsg: "",

      data: null
    };
  },
  computed: {
    ...mapState(["userData"])
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;

      this.$http
        .post(
          this.getUrl,
          this.$qs.stringify({
            target: this.userData.userId
          })
        )
        .then(({ data }) => {
          // console.log(data);
          if (data.RetStatus == 0 && data.RetCode) {
            this.data = data.RetData;
          } else {
            this.error = data.RetStatus;
            this.errorMsg = data.RetMsg;
          }
          this.loading = false;
        })
        .catch(() => {
          this.error = 404;
          this.errorMsg = "加载失败";

          this.loading = false;
        });
    }
  },
  filters: {
    sumCount(arr) {
      let num = 0;
      for (const item of arr) {
        num = num + item.value;
      }
      return num;
    }
  }
};
</script>

<style scoped>
.card-office-list {
  height: 40px;
  padding: 0 20px 0 30px;
}

.card-office-list .card-list-badge {
  background: #c1cbf0;
}

.card-office-title {
  height: 40px;
  padding: 0 20px 0 22px;
}

.card-office-title::before {
  content: "";
  display: block;
  position: absolute;
  left: 12px;
  top: 17px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #bfbfbf;
}

.card-office-title.hover:hover,
.card-office-list:hover {
  background: #eee;
}
</style>
